<template>
  <div class="trail">
    <div v-if="!transactionId || transactionId === ''">
      <md-empty-state
        md-label="No audit selected"
        md-description="Select a row from the transactions list."
      >
      </md-empty-state>
    </div>

    <div v-if="transactionId && transactionId !== ''">
      <h2 class="tab-title">
        {{
          $t("Audit trail for the signature transaction ID:") + transactionId
        }}
      </h2>
      <div class="md-layout md-gutter" style="margin-top: 50px">
        <div class="md-layout-item" v-if="records[currentPage]">
          <div
            class="t-title-type"
            :style="
              'color:' +
              (records[currentPage] && messageTypes[records[currentPage].type]
                ? messageTypes[records[currentPage].type].color
                : '#e94e1b')
            "
          >
            <div
              class="t-number"
              style="cursor: default"
              :style="
                'background:' +
                (records[currentPage] && messageTypes[records[currentPage].type]
                  ? messageTypes[records[currentPage].type].color
                  : '#e94e1b')
              "
            >
              {{ currentPage + 1 }}
            </div>

            <md-icon
              :style="
                'color:' +
                (records[currentPage] && messageTypes[records[currentPage].type]
                  ? messageTypes[records[currentPage].type].color
                  : '#e94e1b')
              "
            >
              {{
                records[currentPage] && messageTypes[records[currentPage].type]
                  ? messageTypes[records[currentPage].type].icon
                  : "assignment"
              }}
            </md-icon>
            <span> {{ records[currentPage].message }}</span>
          </div>
          <div class="t-title-email">{{ records[currentPage].user }}</div>
          <p>Log information:</p>
          <div>
            <md-icon>watch_later</md-icon> <b>Date:</b
            ><span> {{ new Date(records[currentPage].date) }}</span>
          </div>
          <div>
            <md-icon>settings_input_antenna</md-icon> <b>IP-Adress:</b
            ><span> {{ records[currentPage].ip }}</span>
          </div>
          <div>
            <md-icon>devices</md-icon> <b>Browser:</b
            ><span> {{ parseAgent(records[currentPage].agent) }}</span>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter md-alignment-center-center">
        <div
          class="md-layout-item md-size-5"
          v-for="(record, index) in records"
          :key="index"
        >
          <div
            class="t-number audit-selector"
            @click="currentPage = index"
            :class="currentPage == index ? 't-selected' : ''"
            :style="
              'background:' +
              (messageTypes[record.type]
                ? messageTypes[record.type].color
                : '#e94e1b')
            "
          >
            {{ index + 1 }}
          </div>
          <!-- <md-button class="md-fab md-mini"  @click="currentPage = index; " v-if="currentPage == index" style="color:white"
                :style="'background:' + (messageTypes[record.type] ? messageTypes[record.type].color : '#e94e1b') " disabled> 
                {{ index+1 }}
            </md-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import UAParser from "ua-parser-js";

export default {
  name: "Trail",
  components: {},
  props: {
    transactionId: {
      type: String,
      default: null,
    },
  },
  watch: {
    transactionId: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(newVal, oldVal) {
        // do your stuff
        console.log("Prop changed: ", newVal, " | was: ", oldVal);

        this.getAuditTrail();
      },
    },
  },
  data() {
    return {
      records: [],
      currentPage: 0,
      totalPages: 1,
      messageTypes: {
        SENDTOSIGN: {
          color: "#ff5e00",
          icon: "forward_to_inbox",
        },
        SIGN: {
          color: "#e94e1b",
          icon: "create",
        },

        CREATETRANSACTION: {
          color: "#e52b50",
          icon: "flag",
        },
        UPDATETRANSACTION: {
          color: "#e94e1b",
          icon: "add_comment",
        },
        APPROVE: {
          color: "#00c72b",
          icon: "verified",
        },
        REJECT: {
          color: "#D52600",
          icon: "cancel",
        },

        SENDTOAPPROVE: {
          color: "#b0bf1a",
          icon: "forward_to_inbox",
        },
        APPROVE_INIT: {
          color: "#00c72b",
          icon: "verified",
        },
        APPROVE_FINAL: {
          color: "#00c72b",
          icon: "verified",
        },

        EXPIRED: {
          color: "#D52600",
          icon: "cancel",
        },
        REOPEN: {
          color: "#00c296",
          icon: "rotate_left",
        },
      },
    };
  },
  mounted() {},
  methods: {
    parseAgent(agentStr) {
      var ua = UAParser(agentStr);
      // var parser = new UAParser(agentStr);
      // parser;
      return ua.browser.name + " " + ua.os.name + " " + (ua.device.model || "");
    },
    getAuditTrail() {
      if (this.transactionId && this.transactionId !== "") {
        axios({
          method: "get",
          url: "/trail/record",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          params: {
            transactionId: this.transactionId,
          },
        })
          .then((response) => {
            console.log("SUCCESS!!");
            this.records = response.data
              .sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              })
              .reverse();
            this.currentPage = 0;
            this.totalPages = this.records.length;
          })
          .catch(function () {
            console.log("FAILURE!!");
          });
      }
    },
    onClickRecord(event) {
      console.log(event);
      var cont = event.target
        .closest(".t-record")
        .getElementsByClassName("t-body-wrapper")[0];
      cont.classList.toggle("expand");
    },
  },
};
</script>

<style lang="scss">
.t-head {
  display: flex;
}
.t-title-group {
  display: flex;
  margin-left: 25px;
}
.t-number {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background: #e94e1b;
  color: white;
}
.t-number.audit-selector {
  margin-bottom: 5px;
  cursor: pointer;
}
.t-number.audit-selector.t-selected {
  //     border-radius: 40px;
  //         width: 40px;
  // height: 40px;
  // line-height: 40px;
  cursor: default;
}
.t-body-wrapper {
  padding-left: 50px;
  margin-left: 12.5px;
  border-left: 1px solid lightgray;
  min-height: 15px;
  max-height: 0;

  overflow: hidden;
  padding-top: 1px;
  transition: all 1s ease;
}

.t-body-wrapper.expand {
  max-height: 200px !important;
}

.t-title-info {
  margin-left: 5px;
}

.t-title-type {
  font-weight: bold;
  color: #737373;
  font-size: 16px;
}

.t-title-email {
  color: #969696;
  font-size: 12px;
  padding-left: 32px;
}

.t-record {
  margin-top: 40px;
  cursor: pointer;
}
.t-body-content i {
  font-size: 1.2em !important;
}
.t-body-content {
  margin-bottom: 15px;
}

.t-record:last-child .t-body-wrapper {
  border: none;
}
.t-record-group {
  // width: 70%;
  // margin:auto;
}
</style>